import { defineComponent as _defineComponent } from 'vue'
import { useContext } from '@nuxtjs/composition-api';
import { computed } from 'vue';
import { IPromotion } from '~/types/promotion';
import CircularCloseButton from '~/components/UIComponents/CircularCloseButton.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'NftPromotion',
  props: {
    promotion: null
  },
  emits: ['close'],
  setup(__props: any, { emit }) {

const props = __props as {
  promotion: IPromotion;
};




const { $sanityImage, $ua } = useContext();

const itemLogo = computed(() => {
  if (!props.promotion.image) {
    return;
  }
  return `background: url(${props.promotion.image});`;
});

const backgroundImage = computed(() => {
  if (!props.promotion.backgroundImage) {
    return '';
  }

  return `background: url(${props.promotion.backgroundImage});`;
});

const discountSub = computed(() => {
  if (!props.promotion.saleDiscount?.discountSubtitle) {
    return undefined;
  }

  return props.promotion.saleDiscount?.discountSubtitle;
});

return { __sfc: true,emit, props, $sanityImage, $ua, itemLogo, backgroundImage, discountSub, CircularCloseButton }
}

})